import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEO from '@/components/feature/SEO';

const testimonials = [
  {
    name: '张先生',
    role: '互联网从业者',
    content: '自从发现了福利导航，每个月能省下好几百。尤其是信用卡权益那篇文章，让我换了一张更适合自己的卡，每年多拿了好几千的福利。强烈推荐给所有打工人！',
    rating: 5,
  },
  {
    name: '李同学',
    role: '在校大学生',
    content: '作为学生党，福利导航简直是我的省钱神器！通过学生认证福利那篇攻略，我免费领到了好几个平台的会员，一年省下了近千元。文章写得特别详细，照着操作就行。',
    rating: 5,
  },
  {
    name: '王女士',
    role: '职场妈妈',
    content: '真的很实用！特别是租房补贴和公积金那几篇文章，帮我们家庭了解了很多之前不知道的福利政策。已经推荐给了好几个同事，大家都说好。',
    rating: 5,
  },
  {
    name: '赵先生',
    role: '自由职业者',
    content: '银行签到那篇攻略太实用了，每天花几分钟签到，一个月能白拿几十块红包。虽然每次不多，但积少成多，一年下来也有好几百。福利导航的信息都很靠谱。',
    rating: 5,
  },
  {
    name: '陈女士',
    role: '电商运营',
    content: '双十一优惠券攻略那篇文章让我在去年双十一多省了将近一千块！隐藏优惠券的渠道我之前完全不知道。福利导航的每一篇文章都值得认真看。',
    rating: 5,
  },
  {
    name: '刘先生',
    role: '应届毕业生',
    content: '毕业季那篇求职补贴汇总真是及时雨！通过福利导航了解到的信息，我在入职时成功争取到了安家费，HR一开始都没主动提。感谢福利导航！',
    rating: 5,
  },
];

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormStatus('success');
      form.reset();
      setTimeout(() => setFormStatus('idle'), 5000);
      return;
    }

    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9qmq54nlsngrm4lm2ag', {
        method: 'POST',
        body: formData,
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 5000);
      } else {
        const msg =
          (typeof parsed?.meta === 'object' && parsed?.meta !== null && (parsed.meta as Record<string, unknown>)?.message as string) ||
          (typeof parsed?.message === 'string' ? parsed.message : '') ||
          responseText ||
          '提交失败，请稍后重试';
        setFormError(String(msg));
        setFormStatus('error');
      }
    } catch (err: unknown) {
      setFormError(err instanceof Error ? err.message : '网络错误，请稍后重试');
      setFormStatus('error');
    }
  };

  const baseUrl = 'https://fulidaohang.com';

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '福利导航',
        url: baseUrl,
        description: '一站式福利资源聚合平台，为用户汇聚全网优质福利资源。',
        email: 'contact@fulidaohang.com',
        foundingDate: '2024',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'contact@fulidaohang.com',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      },
      {
        '@type': 'WebPage',
        name: '关于我们 - 福利导航',
        description: '了解福利导航的品牌故事、用户口碑评价以及联系方式。',
        url: `${baseUrl}/about`,
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: baseUrl,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '关于我们',
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEO
        title="关于我们 - 福利导航"
        description="了解福利导航的品牌故事与发展历程。福利导航是一站式福利资源聚合平台，为用户汇聚电商优惠、会员权益、生活补贴、职场福利等全网优质福利资源。查看用户口碑评价与联系方式。"
        keywords="关于福利导航,福利导航品牌介绍,福利资源平台,联系我们"
        canonicalUrl="/about"
        schema={schema}
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-background-200/60">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12">
            <Breadcrumb items={[{ label: '关于我们' }]} />
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mt-4 mb-3">
              关于福利导航
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
              一站式福利资源聚合平台，让每个人都能轻松发现好福利
            </p>
          </div>
        </div>

        <section className="w-full max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-16">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">
            <a href="#brand-story">品牌故事</a>
          </h2>
          <div id="brand-story" className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed space-y-4">
            <p>
              福利导航成立于2024年，由一群热爱"薅羊毛"的互联网从业者创建。创始人发现，虽然互联网上有大量的福利资源，但信息分散在各个平台，用户往往需要花费大量时间去搜索和筛选。很多优质的福利因为信息不对称而被埋没，无法触达真正需要它们的人。
            </p>
            <p>
              于是，福利导航应运而生。我们的使命是<strong>让福利信息触手可及</strong>——通过系统化的整理和专业的内容创作，将分散在各处的福利资源汇聚到一个平台上，帮助用户快速找到最适合自己的福利入口。
            </p>
            <p>
              目前，福利导航已经覆盖<strong>电商优惠、会员权益、生活补贴、职场福利、免费福利、金融福利</strong>六大类目，累计发布近百篇原创福利攻略文章，帮助数十万用户发现和享受到了实实在在的福利。
            </p>
            <p>
              我们坚持<strong>人工审核、官方优先、用户至上</strong>的原则，确保每一条福利信息都经过严格核实。我们不只是一个导航平台，更是用户信赖的福利信息顾问。未来，福利导航将持续拓展更多福利类目，优化用户体验，让"发现好福利"这件事变得更简单、更高效。
            </p>
          </div>
        </section>

        <section className="w-full bg-background-100 py-10 md:py-16">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-3">
                <a href="#testimonials">用户口碑</a>
              </h2>
              <p className="text-sm md:text-base text-foreground-600">
                来自真实用户的评价，是我们前进的最大动力
              </p>
            </div>

            <div id="testimonials" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {testimonials.map((t, idx) => (
                <div key={idx} className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/60">
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-500 text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{t.content}&rdquo;
                  </p>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14">
            <div>
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">
                <a href="#contact-info">联系方式</a>
              </h2>
              <div id="contact-info" className="space-y-5">
                <div className="flex items-start gap-4">
                  <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100">
                    <i className="ri-mail-line text-lg text-primary-600"></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-medium text-foreground-900 mb-1">电子邮箱</h4>
                    <p className="text-sm text-foreground-600">contact@fulidaohang.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100">
                    <i className="ri-wechat-line text-lg text-accent-600"></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-medium text-foreground-900 mb-1">微信公众号</h4>
                    <p className="text-sm text-foreground-600">搜索"福利导航"关注我们</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100">
                    <i className="ri-time-line text-lg text-primary-600"></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-medium text-foreground-900 mb-1">工作时间</h4>
                    <p className="text-sm text-foreground-600">周一至周五 9:00 - 18:00</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">
                给我们留言
              </h2>
              <form
                onSubmit={handleSubmit}
                data-readdy-form
                className="space-y-4"
              >
                <div>
                  <label htmlFor="about-name" className="block text-sm text-foreground-700 mb-1.5">
                    您的称呼 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    id="about-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                    placeholder="请输入您的称呼"
                  />
                </div>
                <div>
                  <label htmlFor="about-email" className="block text-sm text-foreground-700 mb-1.5">
                    电子邮箱 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    id="about-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
                <div>
                  <label htmlFor="about-message" className="block text-sm text-foreground-700 mb-1.5">
                    留言内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="about-message"
                    name="message"
                    rows={4}
                    required
                    maxLength={500}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                    placeholder="请输入您的留言内容（最多500字）"
                  ></textarea>
                </div>

                <input
                  name="phone_alt"
                  type="text"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />

                {formStatus === 'success' && (
                  <div className="px-4 py-3 rounded-lg bg-primary-100 text-primary-700 text-sm">
                    留言提交成功！感谢您的反馈，我们会尽快回复。
                  </div>
                )}
                {formStatus === 'error' && (
                  <div className="px-4 py-3 rounded-lg bg-red-50 text-red-600 text-sm">
                    {formError}
                  </div>
                )}

                <button
                  type="submit"
                  className="w-full px-6 py-3 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  提交留言
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}